'use strict'

export let norwegian_endProject={
  Overview: {
    fields: {
      period: {
        title: "Projektets tidsperiode",
        help: "Angi faktisk tidsperiod for prosjektet. Dobbeltklikk på en dato i kalenderen for å angi startdato. Enkeltklikk på en dato for å angi sluttdato."
      },
      summary: {
        title: "Oppsummering",
        help: `Gjennomgå det første godkjente styringsdokumentet. Hva var prosjektets opprinnelige hensikt og hovedmål? I hvilken grad leverte prosjektet det som opprinnelige var forventet? Har vi hatt noen gjennombrudd eller store feil underveis?`,
        description:"Beskriv prosjektets opprinnelige hovedformål og i hvilken grad prosjektet har levert på målene som ble avtalt."
      },
      performedAchivements: {
        title: "Leveranser fra prosjektet",
        help: `Hva dekker den opprinnelige prosjektproduktbeskrivelsen? Hvilke endriner har skjedde med de planlagte produktene i løpet av prosjektets levetid? I hvilken grad opplevde prosjektet at produktene ikke ble levert, ikke levert i tide eller ikke oppfylt de opprinnelige kravene? Har produktene blitt overlevert til mottakerorganisasjonen, var mottakerorganisasjonen forberedt og er produktene akseptert som overlevert?`,
        description: "Hva ble opprinnelig avtalt at prosjektet skulle levere, hva har blitt levert og hvordan er det mottatt?"
      },

      benefits: {
        help: `Se gjennom den opprinnelige begrunnelsen for prosjektet. Er vi på sporet av å levere den ønskede avkastningen på investeringen? Hvis ikke, hva er forskjellen og hvorfor? Er eventuelle nye fordeler lagt til eller fjernet fra begrunnelen til prosjektet?`,
        description: "Vurder hvordan prosjektet har møtt de planlagte gevinstene og begrunnelsen for prosjektet til dags dato."
      },
      time: {
        help: `Hvilke tidsmål var satt i det originale styringsdokumenten og i den opprinnelige prosjektplanen? Hva var tidsambisjonen i prosjektets tidlige dager? Hvordan har prosjektet levert i forhold til disse målene? Hvis tidsfrister ikke ble oppfylt, hva var de viktigste årsakene og faktorene?`,
        description: "Beskriv prosjektets opprinnelige mål på tidsperiode, og vurder hvordan prosjektet er utført i forhold til disse målene"
      },
      cost: {
        help: `Hvilke kostnadsmål fantes for prosjektet i det originale styringsdokumentet og i den opprinnelige prosjektplanen? Hva var kostnadsambisjonen i prosjektets tidlige dager? Hvordan har prosjektet levert i forhold til disse målene? Hvis kostnadsgrenser ble brutt, hva var de viktigste årsakene og faktorene?`,
        description: "Beskriv prosjektets opprinnelige kostnadsmål, og vurder hvordan prosjektet er utført i forhold til disse målene"
      },

      quality: {
        help: `Hvilke høynivå kvalitetsmål og krav eksisterte i den opprinnelige prosjektproduktbeskrivelsen og opprinnelige kravdokumenter? Hvordan har prosjektet levert i forhold til disse kravene? Hvis produktene ble levert som avvik-fra-spesifikasjonen, hva var de viktigste årsakene og faktorene?`,
        description: "Beskriv hva de opprinnelige kravene var og i hvilken grad prosjektet har levert i henhold til disse kravene."
      },
      scope: {
        help: `Hva var definert som omfang i det opprinnelige styringsdokumentet? Hvor stort var prosjektet opprinnelig omfang? Hvilke fagområder, funksjoner og geografiske land var inkludert? Hvilken type endringer har skjedd med omfanget i løpet av prosjektets levetid? I hvilken grad har prosjektet levert på omfanget?`,
        description: "Beskriv hvilke emner eller disipliner som opprinnelig var enige om å være i prosjektet, og i hvilken grad de var dekket under gjennomføringen av prosjektet."
      },

      risk: {
        help: `Hvordan var målet for risiko eller risikovilligheten uttrykt i det originale styringsdokumentet? Hvordan ble risikoen styrt i prosjektet? Var risikoen styrt og rapportert grundig og respondert på riktig måte av interessenter? Hvordan påvirket risikoeksponeringen sluttresultatet av prosjektet?`,
        description: "Beskriv risikovilligheten som ble avtalt tidlig i prosjektet, hvordan ble risikoen styrt og hvordan påvirket risikohendelser prosjektets sluttresultat?"
      }
    }
  }
};



// WEBPACK FOOTER //
// ./views/progress/labels/norwegian_endProject.js